import { z } from 'zod';

/** Zod schema for a CoT point */
export const cotPointSchema = z.object({
  lat: z.number().min(-90).max(90),
  lon: z.number().min(-180).max(180),
  hae: z.number().default(0),
  ce: z.number().default(9999999),
  le: z.number().default(9999999),
});

/** Zod schema for CoT event parameters (for building XML) */
export const cotEventParamsSchema = z.object({
  uid: z.string().min(1),
  type: z.string().min(1),
  lat: z.number().min(-90).max(90),
  lon: z.number().min(-180).max(180),
  callsign: z.string().min(1),
  remarks: z.string().optional(),
  hae: z.number().optional(),
  ce: z.number().optional(),
  le: z.number().optional(),
  how: z.string().optional(),
  staleMinutes: z.number().positive().optional(),
  groupName: z.string().optional(),
  groupRole: z.string().optional(),
});
